module.exports = __webpack_public_path__ + "pic/fav.06964b22.png";